/* eslint-disable no-param-reassign */

var formCheck = require('../forms/check/_index');

class mFormPasswordFields extends HTMLDivElement {
    constructor() {
        super();
        this.oldPasswordField = this.querySelector('#' + this.dataset.sourcename + '-form-old-password');
        this.newPasswordField = this.querySelector('#' + this.dataset.sourcename + '-form-password');
        this.passwordConfirmField = this.querySelector('#' + this.dataset.sourcename + '-form-password-confirm');
        this.onUpdatePassword = this.onUpdatePassword.bind(this);
        this.setFieldsMandatory = this.setFieldsMandatory.bind(this);
    }

    setFieldsMandatory(node, value) {
        node.ariaRequired = value.toString();
        node.required = value;
    }

    onUpdatePassword() {
        if (this.oldPasswordField.value.length
            || this.newPasswordField.value.length
            || this.passwordConfirmField.value.length
        ) {
            // One of the password fields is not empty. Fields become mandatory
            this.setFieldsMandatory(this.oldPasswordField, true);
            this.setFieldsMandatory(this.newPasswordField, true);
            this.setFieldsMandatory(this.passwordConfirmField, true);
        } else {
            // None of the password fields is filled. Fields become optonnal
            formCheck.resetFieldValue(this.oldPasswordField);
            formCheck.resetFieldValue(this.newPasswordField);
            formCheck.resetFieldValue(this.passwordConfirmField);
            this.setFieldsMandatory(this.oldPasswordField, false);
            this.setFieldsMandatory(this.newPasswordField, false);
            this.setFieldsMandatory(this.passwordConfirmField, false);
        }
    }

    connectedCallback() {
        this.passwordConfirmField.addEventListener('change', this.onUpdatePassword);
        this.oldPasswordField.addEventListener('change', this.onUpdatePassword);
        this.newPasswordField.addEventListener('change', this.onUpdatePassword);
        this.oldPasswordField.addEventListener('visibilitychange', (e) => {
            var target = e.currentTarget;
            if (target.visibilityState !== 'visible') {
                formCheck.resetFieldValue(this.oldPasswordField);
                formCheck.resetFieldValue(this.newPasswordField);
                formCheck.resetFieldValue(this.passwordConfirmField);
            }
        });
    }

}

customElements.define('m-form-password-fields', mFormPasswordFields, {
    extends: 'div'
});
